<template>
  <div>
    <h3 class="pt-4">
      Podsumowanie urlopów
    </h3>

    <hr />

    <div class="row">
      <div class="col-md-6">
        <h2>{{year}}</h2>
      </div>

      <div class="col-md-6 text-rigth">
        <b-button-group class="float-right">
          <b-btn variant="outline-primary" @click="setYear(year-1)">{{year-1}}</b-btn>

          <b-btn variant="outline-primary" :disabled="year>=currentYear" @click="setYear(year+1)">{{ year+1 }}</b-btn>
        </b-button-group>
      </div>
    </div>

    <b-alert v-if="summary.length <= 0" show variant="warning">Brak danych</b-alert>

    <table class="table table-hover" v-else>
      <thead>
        <tr>
          <th>Pracownik</th>

          <th>Wszystkie</th>

          <th>Zaakceptowane wolne</th>

          <th>Zaakceptowany rodzaj</th>

          <th>Wykorzystane</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(user, index) in summary" :key="index">
          <td>
            {{ user.firstName }} {{ user.lastName }}
          </td>

          <td class="text-right">
            {{ user.total }}
          </td>

          <td class="text-right">
            {{ user.acceptedManager }}
          </td>

          <td class="text-right">
            {{ user.acceptedHr }}
          </td>

          <td class="text-right">
            {{ user.used }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { DayOffResource } from '@/resources/dayOff.resource';

export default {
  data() {
    return { year: new Date().getFullYear(), summary: [], currentYear: new Date().getFullYear() };
  },
  methods: {
    async refresh() {
      this.summary = await DayOffResource.holidaySummary({ year: this.year });
    },
    setYear(year) {
      this.$router.push({ query: { year } });
    }
  },
  watch: {
    $route(to, from) {
      this.year = +to.query.year || new Date().getFullYear();
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  }
};
</script>

<style
